import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface RoleBadgeProps {
  role: string
  className?: string
}

export function RoleBadge({ role, className }: RoleBadgeProps) {
  const getRoleStyles = (role: string) => {
    switch (role.toLowerCase()) {
      case 'admin':
        return 'bg-error/10 text-error border-error/20'
      case 'manager':
      case 'project_manager':
        return 'bg-primary/10 text-primary border-primary/20'
      case 'team lead':
      case 'team_leader':
        return 'bg-success/10 text-success border-success/20'
      case 'employee':
        return 'bg-muted text-muted-foreground border-border'
      case 'qa':
        return 'bg-accent/10 text-accent border-accent/20'
      case 'executive':
        return 'bg-warning/10 text-warning border-warning/20'
      case 'engineer':
        return 'bg-blue-100 text-blue-800 border-blue-200'
      default:
        return 'bg-muted text-muted-foreground border-border'
    }
  }

  const formatRole = (role: string) => {
    return role.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())
  }

  return (
    <Badge
      variant="outline"
      className={cn(getRoleStyles(role), className)}
    >
      {formatRole(role)}
    </Badge>
  )
}